import React, { Component } from 'react';
import { connect } from 'react-redux';
import JSONViewer from './JSONViewer';

class CustomizingPage extends Component {
  render() {
    const data = this.props.cnbsConfig;
    return (
      <div>
        {/* <ReactJson src={data} theme="rjv-default" iconStyle="triangle" enableClipboard="false" /> */}
        <JSONViewer json={data}></JSONViewer>
      </div>
    );
  }
}
export default connect((store) => ({
  cnbsConfig: store.app.cnbsConfig,
}))(CustomizingPage);